import React, { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { HamburgerIcon } from '@zola/zola-ui/src/components/SvgIcons';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import type { BannerAnimationProps } from 'components/publicWebsiteV2/@types';

import Banner from 'components/publicWebsiteV2/common/Banner/Banner';
import formatLocation from 'components/publicWebsiteV2/util/formatLocation';
import formatDate from 'components/publicWebsiteV2/util/formatDate';
import { ThemeContext } from 'components/publicWebsiteV2/context';
import type { Dayjs } from 'dayjs';
import type { WebsiteDatePublicPropType } from 'util/websiteDateUtil';
import {
  MobileHeaderContainer,
  FullScreenNavMenu,
  Overlay,
  StyledCloseIcon,
  NavItem,
  MobileNavLinkContainer,
  WeddingDetailsText,
  StyledHeaderCart,
} from './MobileHeader.styles';
import { IconContainer } from '../HeaderCart/HeaderCart.styles';

type MobileHeaderProps = BannerAnimationProps & {
  navItems?: WPublicNavItemView[];
  slug?: string;
  city?: string;
  stateProvince?: string;
  title?: string;
  websiteDate?: WebsiteDatePublicPropType<Dayjs>;
};

const MobileHeader = ({
  navItems,
  websiteDate,
  city,
  stateProvince,
  title,
  slug,
  bannerHeight,
  isAnimating,
  onAnimationFinish,
  setBannerHeight,
}: MobileHeaderProps): JSX.Element => {
  const {
    query: { pageType },
  } = useRouter();
  const [showMenu, setShowMenu] = useState(false);

  const location = formatLocation(city, stateProvince);
  const dateText = formatDate(websiteDate);
  const showNavLinks = (navItems || []).length > 1;
  const { light_or_dark } = useContext(ThemeContext);

  return (
    <div>
      <Banner
        setBannerHeight={setBannerHeight}
        bannerHeight={bannerHeight}
        isAnimating={isAnimating}
        onAnimationFinish={onAnimationFinish}
      />
      <Overlay opened={showMenu} onClick={() => setShowMenu(false)} />
      <FullScreenNavMenu opened={showMenu}>
        <StyledCloseIcon width={24} height={24} onClick={() => setShowMenu(false)} />
        {title}
        <WeddingDetailsText>{dateText}</WeddingDetailsText>
        <WeddingDetailsText>{location}</WeddingDetailsText>
        <MobileNavLinkContainer>
          {(navItems || []).map(({ type, nav_title, id }) => {
            return type ? (
              <NavItem
                href={`/wedding-test/${slug}/${((type as unknown) as string).toLowerCase()}`}
                key={id}
              >
                {nav_title}
              </NavItem>
            ) : null;
          })}
        </MobileNavLinkContainer>
      </FullScreenNavMenu>
      <MobileHeaderContainer pageType={pageType as string | undefined} topOffset={bannerHeight}>
        {showNavLinks && (
          <IconContainer mode={light_or_dark} onClick={() => setShowMenu(true)}>
            <HamburgerIcon width={20} height={20} />
          </IconContainer>
        )}
        <StyledHeaderCart />
      </MobileHeaderContainer>
    </div>
  );
};

export default MobileHeader;
